/**
 * 新开业培训
 * @description 新开业邮件通知
 * @author xyguo
 * @date 2021-3-12
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Cascader, InputNumber } from 'antd'
import { component_tool, framework_tool } from '@/tool'
import $$ from 'cmn-utils';
//import "./index.less";
let {
    WizButton,
    WizSelect,
    WizTooltip,
    WizInput,
    WizIcon,
    WizSwitch,
    WizLocationSelect,
    WizRow,
    WizCol,
    WizRadio,
    WizDivider,
    WizCheckbox,
    WizInputNumber
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option
let OptGroup = WizSelect.OptGroup
import { WizTableForm, WizAuthority } from '@/containers/common';
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, userType: 1, organizationIdList: [1141] } })

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class RequirementNoticeForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            date: new Date().getTime()
        }
    }

    componentDidMount() {
    }

    _renderOption() {
        let rows = [
            { code: 110000, codeName: '北京市' },
            { code: 120000, codeName: '天津市' },
            { code: 130000, codeName: '河北省' },
            { code: 140000, codeName: '山西省' },
            { code: 150000, codeName: '内蒙古自治区' },
            { code: 210000, codeName: '辽宁省' },
            { code: 220000, codeName: '吉林省' },
            { code: 230000, codeName: '黑龙江省' },
            { code: 310000, codeName: '上海市' },
            { code: 320000, codeName: '江苏省' },
            { code: 330000, codeName: '浙江省' },
            { code: 340000, codeName: '安徽省' },
            { code: 350000, codeName: '福建省' },
            { code: 360000, codeName: '江西省' },
            { code: 370000, codeName: '山东省' },
            { code: 410000, codeName: '河南省' },
            { code: 420000, codeName: '湖北省' },
            { code: 430000, codeName: '湖南省' },
            { code: 440000, codeName: '广东省' },
            { code: 450000, codeName: '广西壮族自治区' },
            { code: 460000, codeName: '海南省' },
            { code: 510000, codeName: '四川省' },
            { code: 520000, codeName: '贵州省' },
            { code: 530000, codeName: '云南省' },
            { code: 540000, codeName: '西藏自治区' },
            { code: 500000, codeName: '重庆市' },
            { code: 610000, codeName: '陕西省' },
            { code: 620000, codeName: '甘肃省' },
            { code: 630000, codeName: '青海省' },
            { code: 640000, codeName: '宁夏回族自治区' },
            { code: 650000, codeName: '新疆维吾尔自治区' },
            { code: 710000, codeName: '台湾省' },
            { code: 810000, codeName: '香港特别行政区' },
            { code: 820000, codeName: '澳门特别行政区' },
        ]

        let options = []
        rows.forEach(row => {
            let option =
                <WizSelect.Option key={'option' + row['code']} value={row['codeName']} title={row['codeName']}>
                    {row['codeName']}
                </WizSelect.Option>
            options.push(option);
        })
        return (
            options
        )

    }

    renderOtherName(valueRows) {
        let valueRowsNew = []
        valueRows && valueRows.length && valueRows.forEach(e=>{
            valueRowsNew.push({'id':e,'name':e})
        })
        return valueRowsNew
    }

    /**
     * 表单基础内容
     */
    _base() {
        const { data, form } = this.props;
        let { getFieldDecorator } = form;
        return [
            <Item label="省/自治区/直辖市">
                {getFieldDecorator('provincial', {
                    rules: [{ required: true, message: '请选择省/自治区/直辖市' }],
                    initialValue: data.provincial ? data.provincial : [],
                })(
                    <WizSelect
                        placeholder="请选择省/自治区/直辖市"
                        disabled = {data.provincial}
                    >
                        {this._renderOption()}
                    </WizSelect>,
                )}
            </Item>,
            <Item label="别称">
                {getFieldDecorator('anotherNameList', {
                    initialValue: data.anotherNameList || [],
                })(
                    <WizTableForm
                        key={'anotherName' + this.state.date}
                        // onClearWiz={this._onClearWiz3.bind(this)}
                        rowKey='name' rowName='name' rowTitle='name'
                        tableApi={{
                            path: 'requirementNotice/getAnotherNameList',
                            apiParams: {
                            }
                        }}
                        columns={[{
                            title: '名称',
                            name: 'name',
                            dataIndex: 'name',
                            searchItem: {},
                            tableItem: { width: 120 }
                        }]}
                        title={'选择别名'}
                        initRows={data.anotherNameList ? this.renderOtherName(data.anotherNameList) : undefined}
                    />

                )}
            </Item>,
            <Item label="是否为新能源店">
                {getFieldDecorator('isNewEnergy', {
                    rules: [{ required: true,message: '请选择是否为新能源店' }],
                    initialValue: data.isNewEnergy === 0 || data.isNewEnergy ? data.isNewEnergy : undefined
                })(
                    <WizSelect
                        placeholder="请选择是否为新能源店"
                        disabled = {data.isNewEnergy === 0 || data.isNewEnergy === 1}
                    >
                        <Option value={1}>是</Option>
                        <Option value={0}>否</Option>
                    </WizSelect>,
                )}
            </Item>,

            <Item label="管理员" >
                {getFieldDecorator('requirementManagerList', {
                    rules: [{ required: true, message: '请选择管理员' }],
                    initialValue: data[`requirementManagerList`] || [],
                })(
                    <WizTableForm
                        placeholder="请选择管理员"
                        {...userConfig}
                        key={'requirementManagerList' + "@" + this.state.date}
                        //  selectType={'radio'}
                        initRows={data[`personMapList`] ? data[`personMapList`] : []}
                    />
                )}
            </Item>,
            <Item label="状态">
                {getFieldDecorator('state', {
                    rules: [{ required: true, }],
                    initialValue: data.state === 0 ? data.state : 1
                })(
                    <WizRadio.Group>
                        <WizRadio value={1}>有效</WizRadio>
                        <WizRadio value={0}>无效</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item>,

        ]
    }
    handleReset = () => {
        //重置表单
        this.setState({
            date: new Date().getTime()
        })
        this.props.form.resetFields();
    };

    /**
     * 表单提交按钮
     */
    _submit() {
        return (
            <Item wrapperCol={{ span: 12, offset: 6 }}>
                <WizRow>
                    <WizCol span={24} style={{ textAlign: 'center' }}>
                        <WizButton type="primary" htmlType="submit">
                            保存
                        </WizButton>
                        <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                            重置
                        </WizButton>
                    </WizCol>
                </WizRow>
            </Item>
        )
    }

    /**
    * 处理表单提交事件
    */
    handleSubmit = e => {
        let { submit } = this.props;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                submit && submit(values)
            }
        });
    };

    render() {
        let type = this.props.form.getFieldValue("type")
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (
            <WizForm
                {...formItemLayout}
                onSubmit={this.handleSubmit}
            >
                {this._base()}
                {this._submit()}
            </WizForm>
        )
    }
}

export default WizForm.create()(RequirementNoticeForm);



